import { render, staticRenderFns } from "./EditConsultantSeller.vue?vue&type=template&id=5935cb7e"
import script from "./EditConsultantSeller.vue?vue&type=script&lang=js"
export * from "./EditConsultantSeller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports